module.exports = __webpack_public_path__ + "6097159212b234688054da273fd45ea9.jpg";